export function calculateDaysBetween(date1, date2) {
    // Parse the date strings into Date objects
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Calculate the difference in milliseconds
    // const diffInMs = Math.abs(d2 - d1); //We don't need the absolute value because we are comparing the two dates
    const diffInMs = d2 - d1;    


    // Convert milliseconds to days
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    // console.log(diffInDays)

    return diffInDays;
}